import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

export const mfeErrorPlugin: ModuleFederationRuntimePlugin = {
    name: 'mfe-error-plugin',
    errorLoadRemote: async (args) => {
        // Throw the error to allow route-level error handling to take over
        // Error will be logged by loadRemoteComponent/loadRemoteRoutes with more context
        throw args.error;
    }
};
